import React from "react";
import {useSelector} from "react-redux";
import {selectTopViewWallAreas} from "../../topViewWallArea/topViewWallAreaSlice";
import EditorPanelTabContent from "../EditorPanelTabContent";
import TopViewWallAreaPanelItem from "./TopViewWallAreaPanelItem";

const TopViewWallAreaPanelTab: React.FC = () => {
	const measurements = useSelector(selectTopViewWallAreas);

	return (
		<EditorPanelTabContent>
			{measurements.map(measurement => (
				<TopViewWallAreaPanelItem key={measurement.id} measurement={measurement}/>
			))}
		</EditorPanelTabContent>
	);
};

export default TopViewWallAreaPanelTab;
